import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from './ui/button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                <AlertCircle className="h-8 w-8 text-red-600" />
              </div>
              <h1 className="text-2xl font-bold text-[#2C3E50] mb-2">
                Etwas ist schiefgelaufen
              </h1>
              <p className="text-gray-600 mb-6">
                Die Seite konnte nicht korrekt geladen werden. Bitte versuchen Sie es erneut.
              </p>
              <Button
                onClick={this.handleReload}
                className="bg-[#FDB913] hover:bg-[#F59E0B] text-[#1a1a1a] font-bold"
              >
                Seite neu laden
              </Button>
              {this.state.error && (
                <details className="mt-6 text-left w-full">
                  <summary className="cursor-pointer text-sm text-gray-500 hover:text-gray-700">
                    Fehlerdetails anzeigen
                  </summary>
                  <div className="mt-2 p-4 bg-gray-100 rounded text-xs font-mono overflow-auto max-h-64">
                    <p className="text-red-600 font-bold mb-2">{this.state.error.toString()}</p>
                    <pre className="whitespace-pre-wrap">
                      {this.state.errorInfo?.componentStack}
                    </pre>
                  </div>
                </details>
              )}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
